"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCorrectPhoneNumber = exports.phoneValidate = exports.cleanPhoneNumber = void 0;
const cleanPhoneNumber = (p) => p.startsWith("98") ? "0" + p.substring(2) : p;
exports.cleanPhoneNumber = cleanPhoneNumber;
const phoneValidate = (value, zeroOptional = true) => {
    const v = zeroOptional && !(value.startsWith("0") || value.startsWith("۰"))
        ? "0" + value
        : value;
    return Boolean(v.match(/^[0۰][0-9۰-۹]{10}$/g));
};
exports.phoneValidate = phoneValidate;
const getCorrectPhoneNumber = (p) => {
    if (p === "") {
        return "";
    }
    return p.startsWith("98")
        ? "0" + p.substring(2)
        : p.startsWith("0")
            ? p
            : "0" + p;
};
exports.getCorrectPhoneNumber = getCorrectPhoneNumber;
//# sourceMappingURL=phone.js.map